import { colors } from '../../colors';
var anchor = {
  anchorColor: colors.slateGrey
};
export default anchor;